module.exports = __webpack_public_path__ + "static/media/PA-Icon-Baby-pos.06b009b7.svg";